<template>
  <section id="onboarding" class="bd-index-fullscreen has-page-background hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6 has-text-centered">
            <form @submit.prevent="validateBeforeSubmit">
              <div v-if="onboardingStep === 1">
                <!--<img src="@/assets/logo.png" alt="Image" width="20%">-->
                <h3>{{ $t('newuser.welcome') }} <span class="has-text-brand">{{ userProfile.name }}</span></h3>
                <p class="has-text-grey-light">
                  {{ $t('newuser.welcome-message') }}
                </p>
                <hr class="is-dark" />


                <p class="has-margin-bottom-20 is-size-5">{{ $t('newuser.registering-option') }}</p>
                <div class="columns">
                  <div class="column">
                    <a @click.prevent="setType('Individual')" class="button is-mega is-primary is-outlined is-fullwidth">  
                       <i class="ri-user-line has-text-warning is-size-4"></i>
                      <br />
                      <div>{{ $t('newuser.button-individual') }}</div>
                    </a>
                  </div>
                  <div class="column">
                    <a @click.prevent="setType('Business')" class="button is-mega is-primary is-outlined is-fullwidth">
                      <i class="ri-building-2-line has-text-warning is-size-4"></i>
                      <br />
                      <div>
                        {{ $t('newuser.button-business') }}
                      </div>
                    </a>
                  </div>
                </div>
                <!--
                <b-field>
                  <b-radio-button v-model="userProfile.type"
                    native-value="Individual"
                    type="is-primary">
                    <b-icon icon="account"></b-icon>
                    <span>Individual</span>
                  </b-radio-button>
                  <b-radio-button v-model="userProfile.type"
                    native-value="Business"
                    type="is-success">
                    <b-icon icon="business"></b-icon>
                    <span>Business/Organisation</span>
                  </b-radio-button>
                </b-field>-->

                <!--
                <hr class="is-dark" />
                <p class="has-text-grey-light">
                  Accounts are seperated from business an individual user, this keeps the objective clean
                  makes it easier to hand over an account if a invidiual moves on form a business.
                </p>
                <img src="@/assets/logo.png" alt="Osla Social" width="20%">
                -->
              </div>
            
              <div v-if="onboardingStep === 2">
                <div class="has-text-left">
                  <a @click.prevent="prev()">
                    <i class="ri-arrow-left-line has-text-info"></i>
                  </a>
                </div>
                <div v-if="userProfile.type == 'Business'">
                  <h3>{{ $t('newuser.button-business') }} <span class="has-text-brand">{{ userProfile.name }}</span></h3>
                  <p class="has-text-grey-light">
                    {{ $t('newuser.additional-info') }}
                  </p>
                  <hr class="is-dark" />
                  <div class="has-text-left">
                    <b-field>
                      <b-input 
                        v-model.trim="userProfile.location" 
                        :placeholder="$t('newuser.input-ph-location')"
                        maxlength="20" 
                        type="text" 
                        id="location">
                      </b-input>
                    </b-field>
                    <button type="submit" class="button is-primary">
                      {{ $t('newuser.button-continue') }}&nbsp;<i class="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div>
                <div v-else>
                  <h3>{{ $t('newuser.button-individual') }} <span class="has-text-brand">{{ userProfile.name }}</span></h3>
                  <p class="has-text-grey-light">
                    {{ $t('newuser.additional-info') }}
                  </p>
                  <div class="has-text-left">
                    <hr class="is-dark" />
                    <b-field>
                      <b-input 
                        v-model.trim="userProfile.position" 
                        :placeholder="$t('newuser.input-ph-position')"
                        maxlength="20" 
                        type="text" 
                        id="position">
                      </b-input>
                    </b-field>
                    <b-field>
                      <b-input 
                        v-model.trim="userProfile.location" 
                        :placeholder="$t('newuser.input-ph-location')"
                        maxlength="20" 
                        type="text" 
                        id="location">
                      </b-input>
                    </b-field>
                    <!--<b-button @click="updateProfile" type="is-primary">Update Profile</b-button>-->
                    <button type="submit" class="button is-primary">
                      {{ $t('newuser.button-continue') }}&nbsp;<i class="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div>
                <!--
                <button class="button is-primary" @click.prevent="submit()">Save</button>
                -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      /*
      userPost: {
        title: "",
        content: "",
        website: "",
        imageUrl: "",
        score: "",
      },*/

      position: "",
      location: "",
      type: "",

      onboardingStep: 1,
    };
  },
  computed: {
    ...mapState(["userProfile"]),
  },
  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch(err => {
          console.log(err);
        });
    },

    prev() {
      this.onboardingStep--;
    },
    setType(selectedType){
      this.userProfile.type = selectedType;
      console.log("UserType: " + selectedType);
      this.onboardingStep++;
    },
    
    
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true;
          this.updateProfile();
          return;
        }
        this.$toast.open({
          duration: 3000,
          message: this.$t("newuser.toast-form-invalid"),
          position: "is-bottom",
          type: "is-danger"
        });
        this.scrollTo();
      });
    },
    scrollTo() {
      var element = '#settings';
      var duration = 300;
      var options = {
        easing: 'ease-in',
        offset: -80,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      this.$scrollTo(element, duration, options)
    },

    updateProfile() {
      this.$store.dispatch("updateProfile", {
        name: this.userProfile.name,
        position: this.position !== "" ? this.position : this.userProfile.position,
        location: this.location !== "" ? this.location : this.userProfile.location,
        type: this.type !== "" ? this.type : this.userProfile.type
      }).then(user => {
        this.snackbarSuccess();
        this.isLoading = false;
        this.$router.push("/posts");
      }, error => {
        console.error("Got nothing from server.")
        this.snackbarError();
        this.isLoading = false;
      })
    },
    snackbarSuccess() {
      this.$snackbar.open({
        duration: 4000,
        message: this.$t("newuser.snackbar-success"),
        type: 'is-primary',
        position: 'is-bottom',
        actionText: null,
        class: 'has-background-info',
        queue: false,
        /*
        onAction: () => {
          this.$router.push("/posts");
        }*/
      })
    },
    snackbarError() {
      this.$snackbar.open({
        duration: 4000,
        message: this.$t("newuser.snackbar-error"),
        type: 'is-info',
        position: 'is-bottom',
        actionText: 'Ok',
        queue: false,
        onAction: () => {
          this.$router.push("/newuser");
        }
      })
    },
    
  },
  filters: {
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  }
};
</script>